import { getApiBaseUrl } from "../../utils/apiBaseUrl";

export const socialLogin = async (
  provider: "google" | "apple",
  token: string
) => {
  const baseUrl = getApiBaseUrl();

  const res = await fetch(`${baseUrl}/api/Auth/social-login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      provider,
      token,
    }),
  });

  if (!res.ok) throw new Error("Login failed");

  return res.json();
};